<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';
    import Card from '@/components/UI/Card/Card.vue';
    import CardTitle from '@/components/UI/Card/Title.vue';
    import CardImage from '@/components/UI/Card/Image.vue';
    import CardImagePlaceholder from '@/components/UI/Card/ImagePlaceholder.vue';
    import CardBody from '@/components/UI/Card/Body.vue';

    export default {
        Card,
        CardTitle,
        CardSubTitle: defineAsyncComponent(() => import(/* webpackChunkName: "ui-card" */'@/components/UI/Card/SubTitle.vue')),
        CardImage,
        CardProfileImage: defineAsyncComponent(() => import(/* webpackChunkName: "ui-card" */'@/components/UI/Card/ProfileImage.vue')),
        CardImagePlaceholder,
        CardText: defineAsyncComponent(() => import(/* webpackChunkName: "ui-card" */'@/components/UI/Card/Text.vue')),
        CardBody,
        CardFooter: defineAsyncComponent(() => import(/* webpackChunkName: "ui-card" */'@/components/UI/Card/Footer.vue')),
    }
</script>